enum KeyEventEnum {
  Enter = 'Enter',
}

export default KeyEventEnum;
